import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const SendIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 20 20" title={t`Send`} {...props}>
    <Path
      d="M18.9439 2.33035C19.0708 1.96776 18.9787 1.56453 18.7071 1.29289C18.4355 1.02126 18.0322 0.929236 17.6696 1.05614L1.66965 6.65614C1.28265 6.79159 1.01754 7.14956 1.00083 7.55924C0.984117 7.96892 1.21918 8.34729 1.59386 8.51381L8.4424 11.5576L11.4862 18.4061C11.6527 18.7808 12.0311 19.0159 12.4408 18.9992C12.8504 18.9825 13.2084 18.7174 13.3439 18.3304L18.9439 2.33035Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
